const fetchClientInstance = async (url: string, options = {}): Promise<any> => {
    const response = await fetch(url, options);

    if (response.status === 503) {
        if (typeof window !== "undefined") {
            window.location.href = "/maintance";
            return null;
        }
    }

    return response;
};

export { fetchClientInstance }
